import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// fake language resource when no language has been loaded yet - to aviod warning
const resources = { xx: { translation: { } } };

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'xx',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
